import React from 'react';

function QueueImputs(props) {
  const { changeValues } = props;
  /*
    IP:
      {
        queueName character varying(128),
        queueMusicOnHold character varying(128),
        queueStrategy queue_strategy_values, -- ringall, leastrecent, fewestcalls, random, rrmemory, linear, wrandom, rrordered
        queueAutoFill yesno_values, -- yes or no
        queueMaxLen integer,
        queueRinginuse yesno_values, -- yes or no
        queueAnnouncePosition yesno_values, -- yes or no
        queueAnnounceFrequency integer,
        queueAnnounceHoldTime yesno_values, -- yes or no
        queueMinAnnounceFrequency integer,
        queueSetQueueEntryVarQueue yesno_values, -- yes or no
        queueWrapuptime integer,
        queueJoinempty character varying(128),
        queueLeavewhenempty character varying(128)
      }
  */

  return (
    <div>
      <div className="columns mx-2">
        <div className="column is-3 field">
          <label className="label">Nome da Fila
            <div className="control">
              <input className="input" name="name" type="text" onChange={(e) => changeValues(e.target)} placeholder="Nome" />
              <p name="name-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field">
          <label className="label">Música
            <div className="control">
              <div name="music" className="select is-fullwidth">
                <select className="select" name="music" onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="default">Música Padrão</option>
                </select>
              </div>
              <p name="music-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-3 field">
          <label className="label">Estratégia
            <div className="control">
              <div name="strategy" className="select is-fullwidth">
                <select className="select" name="strategy" onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="ringall">Tocar Todos</option>
                  <option value="linear">Linear</option>
                </select>
              </div>
              <p name="strategy-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field">
          <label className="label">Segunda Chamada
            <div className="control">
              <div name="ringinuse" className="select is-fullwidth">
                <select className="select" name="ringinuse" onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="yes">Sim</option>
                  <option value="no">Nao</option>
                </select>
              </div>
              <p name="ringinuse-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-1 field">
          <label className="label">Descanso
            <div className="control">
              <input className="input" name="wrapuptime" type="number" onChange={(e) => changeValues(e.target)} placeholder="3" />
              <p name="wrapuptime-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
      </div>
      <div className="columns mx-2">
        <div className="column is-2 field">
          <label className="label">Anúncio Posição Fila
            <div className="control">
              <div name="announcePosition" className="select is-fullwidth">
                <select className="select" name="announcePosition" onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="yes">Sim</option>
                  <option value="no">Nao</option>
                </select>
              </div>
              <p name="announcePosition-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field">
          <label className="label">Anún. Tempo Estimado
            <div className="control">
              <div name="announceHoldTime" className="select is-fullwidth">
                <select className="select" name="announceHoldTime" onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="yes">Sim</option>
                  <option value="no">Nao</option>
                </select>
              </div>
              <p name="announceHoldTime-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-1 field">
          <label className="label">Mínimo
            <div className="control">
              <input className="input" name="minAnnounceFrequency" type="number" onChange={(e) => changeValues(e.target)} placeholder="35" />
              <p name="minAnnounceFrequency-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-1 field">
          <label className="label">Freq.
            <div className="control">
              <input className="input" name="announceFrequency" type="number" onChange={(e) => changeValues(e.target)} placeholder="35" />
              <p name="announceFrequency-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field">
          <label className="label">Entrar (Se Vazia)
            <div className="control">
              <div name="joinempty" className="select is-fullwidth">
                <select className="select" name="joinempty" onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="yes">Sim</option>
                  <option value="no">Nao</option>
                  <option value="strict">Restrito</option>
                </select>
              </div>
              <p name="joinempty-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field">
          <label className="label">Sair (Se Vazia)
            <div className="control">
              <div name="leavewhenempty" className="select is-fullwidth">
                <select className="select" name="leavewhenempty" onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="yes">Sim</option>
                  <option value="no">Nao</option>
                  <option value="strict">Restrito</option>
                </select>
              </div>
              <p name="leavewhenempty-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-1 field">
          <label className="label"> Chamadas
            <div className="control">
              <input className="input" name="maxlen" type="number" onChange={(e) => changeValues(e.target)} placeholder="35" />
              <p name="maxlen-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
}

export default QueueImputs;
